export enum BackgroundEnum {
  LOGIN = '/login-bg.jpg',
  BANNER800 = '/banner-800-x-950.jpg',
  BANNER1920 = '/banner-1920-x-1200.jpg',
}
